export interface TimeRange {
  Start: string;
  End: string;
}

export enum DatalossRequestTypes {
  GetDetectionEventRecordsInTimeRangeRequest = 'detectionEventRecords.getAllInTimeRange.request',
  GetDetectionEventRecordsInTimeRangeSuccess = 'detectionEventRecords.getAllInTimeRange.success',
  GetDetectionEventRecordsInTimeRangeFailure = 'detectionEventRecords.getAllInTimeRange.failure',
  GetDetectionEventRecordRequest = 'detectionEventRecords.getDetectionEventRecord.request',
  GetDetectionEventRecordSuccess = 'detectionEventRecords.getDetectionEventRecord.success',
  GetDetectionEventRecordFailure = 'detectionEventRecords.getDetectionEventRecord.failure',
  UpdateDetectionEventRecordRequest = 'detectionEventRecords.update.request',
  UpdateDetectionEventRecordSuccess = 'detectionEventRecords.update.success',
  UpdateDetectionEventRecordFailure = 'detectionEventRecords.update.failure',
  CategorizeDetectionEventRecordRequest = 'detectionEventRecords.categorize.request',
  CategorizeDetectionEventRecordSuccess = 'detectionEventRecords.categorize.success',
  CategorizeDetectionEventRecordFailure = 'detectionEventRecords.categorize.failure',
  FetchAllIncidentsRequest = 'datalossIncidents.fetchAll.request',
  FetchAllIncidentsSuccess = 'datalossIncidents.fetchAll.success',
  FetchAllIncidentsFailure = 'datalossIncidents.fetchAll.failure',
  FetchAllDatalossIgnoresRequest = 'datalossIgnores.fetchAll.request',
  FetchAllDatalossIgnoresSuccess = 'datalossIgnores.fetchAll.success',
  FetchAllDatalossIgnoresFailure = 'datalossIgnores.fetchAll.failure',
  UpdateDatalossIgnoresRequest = 'datalossIgnores.update.request',
  UpdateDatalossIgnoresSuccess = 'datalossIgnores.update.success',
  UpdateDatalossIgnoresFailure = 'datalossIgnores.update.failure',
  DeleteSegmentRequest = 'detections.deleteSegment.request',
  DeleteSegmentSuccess = 'detections.deleteSegment.success',
  DeleteSegmentFailure = 'detections.deleteSegment.failure',
}
